import { Box, BoxProps, Typography } from "@mui/material";
import { PropsWithChildren, ReactNode } from "react";
import { BasicSquaredCard } from "src/components/cards/deprecated/BasicSquaredCard";

export interface QuickLinkCardProps extends BoxProps {
    /**
     * The Image is positioned in the top left corner and has a height and with of 48px
     */
    image?: ReactNode;
}

/**
 * QuickLinkCard used to display an icon in the top left corner and some text in the bottom left corner.
 */
export const QuickLinkCard = (props: PropsWithChildren<QuickLinkCardProps>) => {
    return (
        <BasicSquaredCard onClick={props.onClick}>
            <Box
                sx={{
                    width: "100%",
                    height: "100%",
                    display: "grid",
                    alignContent: "space-between",
                }}
            >
                <Box width={48} height={48} display={"flex"} alignItems={"center"} justifyContent={"center"}>
                    {props.image}
                </Box>

                <Typography
                    variant={"h4"}
                    sx={{
                        color: "text.primary",
                        textTransform: "none",
                        hyphens: "auto",
                        hyphenateCharacter: "auto",
                    }}
                >
                    {props.children}
                </Typography>
            </Box>
        </BasicSquaredCard>
    );
};
